export const CATEGORIES = [
  { id: "manger", icon: "Utensils", color: "#D95D39", label: { fr: "Manger", en: "Eat", es: "Comer" }, sub: { fr: "Restos & Paellas", en: "Eats & Paellas", es: "Comer & Paellas" } },
  { id: "sortir", icon: "Wine", color: "#7C3AED", label: { fr: "Sortir", en: "Go out", es: "Salir" }, sub: { fr: "Bars & Nuit", en: "Nightlife & Bars", es: "Bares & Noche" } },
  { id: "visiter", icon: "Landmark", color: "#0F4C5C", label: { fr: "Visiter", en: "Visit", es: "Visitar" }, sub: { fr: "Culture & Histoire", en: "Culture & Heritage", es: "Cultura & Historia" } },
  { id: "faire", icon: "Bike", color: "#38B000", label: { fr: "Faire", en: "Do", es: "Hacer" }, sub: { fr: "Activités & Mer", en: "Activities & Sea", es: "Actividades & Mar" } },
  { id: "evenements", icon: "CalendarDays", color: "#FB8B24", label: { fr: "Événements", en: "Events", es: "Eventos" }, sub: { fr: "Fêtes & Shows", en: "Festas & Shows", es: "Fiestas & Shows" } },
];

export const CATEGORY_COLORS = CATEGORIES.reduce((a, c) => ((a[c.id] = c.color), a), {});

export const INTENTS = [
  { key: "tonight", icon: "Moon", label: { fr: "Ce soir", en: "Tonight", es: "Esta noche" }, params: { open_now: true, ideal_evening: true } },
  { key: "low_budget", icon: "PiggyBank", label: { fr: "Petit budget", en: "Low budget", es: "Bajo presupuesto" }, params: { price_max: 1 } },
  { key: "near_me", icon: "Navigation", label: { fr: "Près de moi", en: "Near me", es: "Cerca de mí" }, params: { sort: "distance" }, geo: true },
  { key: "first_time", icon: "Sparkles", label: { fr: "Première fois à Valence", en: "First time in Valencia", es: "Primera vez en Valencia" }, params: { good_first_visit: true } },
  { key: "couple", icon: "Heart", label: { fr: "En couple", en: "As a couple", es: "En pareja" }, params: { tags: "romantique" } },
  { key: "friends", icon: "Users", label: { fr: "Entre amis", en: "With friends", es: "Con amigos" }, params: { category: "sortir" } },
  { key: "student", icon: "GraduationCap", label: { fr: "Étudiant", en: "Student", es: "Estudiante" }, params: { popular_students: true } },
  { key: "rainy", icon: "CloudRain", label: { fr: "Quand il pleut", en: "When it rains", es: "Cuando llueve" }, params: { best_moment: "rainy" } },
  { key: "two_hours", icon: "Clock", label: { fr: "2 heures libres", en: "2 free hours", es: "2 horas libres" }, params: {}, maxDuration: 120 },
];

export const TAGS = {
  nautique: { fr: "Nautique", en: "Nautical", es: "Náutico" },
  historique: { fr: "Historique", en: "Historic", es: "Histórico" },
  romantique: { fr: "Romantique", en: "Romantic", es: "Romántico" },
  etudiant: { fr: "Étudiant", en: "Student", es: "Estudiante" },
  premium: { fr: "Premium", en: "Premium", es: "Premium" },
  "petit-budget": { fr: "Petit budget", en: "Low budget", es: "Barato" },
  famille: { fr: "Famille", en: "Family", es: "Familia" },
  sunset: { fr: "Sunset", en: "Sunset", es: "Atardecer" },
  indoor: { fr: "Indoor", en: "Indoor", es: "Interior" },
  outdoor: { fr: "Outdoor", en: "Outdoor", es: "Exterior" },
  local: { fr: "Local", en: "Local", es: "Local" },
  touristique: { fr: "Touristique", en: "Touristy", es: "Turístico" },
  paella: { fr: "Paella", en: "Paella", es: "Paella" },
  tapas: { fr: "Tapas", en: "Tapas", es: "Tapas" },
  cafe: { fr: "Café", en: "Café", es: "Café" },
  brunch: { fr: "Brunch", en: "Brunch", es: "Brunch" },
  cocktails: { fr: "Cocktails", en: "Cocktails", es: "Cócteles" },
  plage: { fr: "Plage", en: "Beach", es: "Playa" },
  nature: { fr: "Nature", en: "Nature", es: "Naturaleza" },
  sport: { fr: "Sport", en: "Sport", es: "Deporte" },
  art: { fr: "Art", en: "Art", es: "Arte" },
  culture: { fr: "Culture", en: "Culture", es: "Cultura" },
};

export const FILTER_TAGS = ["nautique", "historique", "romantique", "etudiant", "premium", "petit-budget", "famille", "sunset", "indoor", "outdoor", "local", "touristique"];

export const BEST_MOMENTS = {
  morning: { fr: "Matin", en: "Morning", es: "Mañana" },
  sunset: { fr: "Coucher de soleil", en: "Sunset", es: "Atardecer" },
  evening: { fr: "Soirée", en: "Evening", es: "Noche" },
  rainy: { fr: "Jour de pluie", en: "Rainy day", es: "Día de lluvia" },
  weekend: { fr: "Week-end", en: "Weekend", es: "Fin de semana" },
};

export const NEIGHBORHOODS = ["Ruzafa", "El Carmen", "Ciutat Vella", "Benimaclet", "Cabanyal", "Malvarrosa", "Ciutat de les Arts", "La Marina", "Turia"];

export function priceSymbol(level) {
  return "€".repeat(Math.max(1, Math.min(3, level || 1)));
}

export const VLC_CENTER = [39.4699, -0.3763];
